export const foodData = [
    {
        id: 1,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717389008/spc/shopping_ccxcmm.webp',
        description: 'Pedigree Meat & Rice Adult Dog Dry Food - 20Kg',
    },
    {
        id: 2,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717389471/spc/shopping_1_z30axp.webp',
        description: 'Pedigree for Puppy Dry Food - 20Kg',
    },
    {
        id: 3,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717390007/spc/shopping_6_pvv6uf.webp',
        description: 'Pedigree Puppy Dog Food With Chicken & Milk 3 Kg',
    },
    {
        id: 4,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717389779/spc/shopping_4_xovqdr.webp',
        description: 'Pedigree PRO Expert Nutrition Active Adult Dry Dog Food',
    },
];